import React, { useEffect, useState } from "react";
import { GiphyFetch } from "@giphy/js-fetch-api";

export const useSearch = () => {
  const [data, setData] = useState<any[]>([]);
  const [query, setQuery] = useState("");
  const [loading, setLoading] = useState(true);
  
  const client_id: any = process.env.REACT_APP_GIPHY_STICKER_API_KEY;
  const gf = new GiphyFetch(client_id);

  async function searchStickers({offset}: {offset: number}){
    const results = await gf.search(query, { offset, type: "stickers" });
    setData(results.data)
    return results.data;
  };

  useEffect(() => {
    const controller = new AbortController();
    setLoading(true);
    //@ts-ignore
    searchStickers(data.length)

    return () => controller.abort();
  }, [query]);

  async function loadNextPage() {
    setLoading(true)
    const results = await gf.search(query, { offset: data.length, type: 'stickers' });
    const d = data
    
    setData([...d, ...results.data]);
    setLoading(false);
  };

  const search = (query: any) => {
    setData([]);
    setQuery(query);
  };

  return { data, loading, loadNextPage, search };
};